/* eslint-disable */

const DEFAULT_ADMIN_BRAND = "#4f46e5";

function normaliseHex(value, fallback = DEFAULT_ADMIN_BRAND) {
  const raw = String(value || "").trim();
  if (/^#[0-9a-fA-F]{6}$/.test(raw)) return raw;
  if (/^#[0-9a-fA-F]{3}$/.test(raw)) {
    return `#${raw[1]}${raw[1]}${raw[2]}${raw[2]}${raw[3]}${raw[3]}`.toLowerCase();
  }
  return fallback;
}

function hexToRgb(hex) {
  const safe = normaliseHex(hex).replace("#", "");
  return {
    r: parseInt(safe.slice(0, 2), 16),
    g: parseInt(safe.slice(2, 4), 16),
    b: parseInt(safe.slice(4, 6), 16),
  };
}

function rgbToHex({ r, g, b }) {
  return `#${[r, g, b]
    .map((n) => Math.max(0, Math.min(255, Math.round(n))).toString(16).padStart(2, "0"))
    .join("")}`;
}

function mix(hex, target, amount = 0.2) {
  const a = hexToRgb(hex);
  const b = hexToRgb(target);
  return rgbToHex({
    r: a.r + (b.r - a.r) * amount,
    g: a.g + (b.g - a.g) * amount,
    b: a.b + (b.b - a.b) * amount,
  });
}

function rgba(hex, alpha = 1) {
  const { r, g, b } = hexToRgb(hex);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}

export function getAdminBrand(primaryColor) {
  const primary = normaliseHex(primaryColor);
  const dark = mix(primary, "#0f172a", 0.34);
  const soft = mix(primary, "#ffffff", 0.86);
  const mid = mix(primary, "#ffffff", 0.45);

  return {
    primary,
    dark,
    soft,
    mid,
    glow: rgba(primary, 0.24),
    gradient: `linear-gradient(135deg, ${primary} 0%, ${dark} 100%)`,
    softGradient: `linear-gradient(180deg, ${rgba(primary, 0.12)} 0%, ${rgba(primary, 0.035)} 100%)`,
    darkGradient: `radial-gradient(circle at top right, ${rgba(primary, 0.28)}, transparent 32%), linear-gradient(135deg, #0f172a 0%, ${dark} 100%)`,
  };
}

export function getAdminBrandVars(primaryColor) {
  const brand = getAdminBrand(primaryColor);
  return {
    "--pp-primary": brand.primary,
    "--pp-primary-dark": brand.dark,
    "--pp-primary-soft": brand.soft,
    "--pp-primary-mid": brand.mid,
    "--pp-brand-glow": brand.glow,
    "--pp-brand-gradient": brand.gradient,
    "--pp-brand-soft-gradient": brand.softGradient,
    "--pp-brand-dark-gradient": brand.darkGradient,
  };
}

export function adminBrandGradient(primaryColor) {
  return getAdminBrand(primaryColor).gradient;
}
